/**
 * Title-case a display string.
 * `"activewear"` → `"Activewear"`, `"thigh protectors"` → `"Thigh Protectors"`.
 */
export function toTitleCase(value: string): string {
  return value
    .trim()
    .split(/[\s_]+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split("-")
        .map((part) => {
          if (!part) return part;
          const lower = part.toLowerCase();
          return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join("-"),
    )
    .join(" ");
}
